import RouterGuard from './_RouterGuards'
import JobBoard from '../components/jobBoard/JobBoardIndex'
import JobPost from '../components/jobBoard/JobPost'
import store from '../store'
import JobBoardMetrics from '../components/jobBoard/JobBoardMetrics'

export default {
  jobBoardIndex: {
    path: '/job-board',
    name: 'Job Board Index',
    component: JobBoard,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  jobBoardMetrics: {
    path: '/job-board/metrics',
    name: 'Job Board Metrics',
    component: JobBoardMetrics,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  createJobPost: {
    path: '/job-board/create',
    name: 'Create Job Post',
    component: JobPost,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  jobPost: {
    path: '/job-board/:id',
    name: 'Job Post',
    component: JobPost,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/jobBoard.js